import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Observable, pipe } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { Blog, BlogEntry, BlogState, CallState, ErrorState, LoadingState } from './ubs-blog-model';
import { UbsBlogService } from './ubs-blog.service';

const DEFAULT_STATE: BlogState = {
  blogs:[],
  selectedBlog:{"blogContentId":"","contentName":""},
  blogEntries:[],
  selectedBlogEntry:{"contentId":""},
	showFirstEntry: true,
	useLocation:false,
  callState:LoadingState.INIT
};

// Utility function to extract the error from the state
function getError(callState: CallState): LoadingState | string | null {
  if ((callState as ErrorState).errorMsg !== undefined) {
    return (callState as ErrorState).errorMsg;
  }

  return null;
}

@Injectable()
export class UbsBlogStoreService  extends ComponentStore<BlogState>{

  constructor(private blogService:UbsBlogService) { 
    super(DEFAULT_STATE)
  }
  // Selectors

  //blogEntriesStart$ = this.blogService.getBlogEntries().subscribe();
  readonly blogs$:Observable<Blog[]> = this.select(state => state.blogs);
  readonly blog$:Observable<Blog> = this.select(state => state.selectedBlog);
  readonly blogEntries$:Observable<BlogEntry[]> = this.select(state => state.blogEntries);
  readonly selectedBlogEntry$:Observable<BlogEntry> = this.select(state => state.selectedBlogEntry);
  readonly showFirstEntry$:Observable<boolean> = this.select(state => state.showFirstEntry);
  readonly useLocation$:Observable<boolean> = this.select(state => state.useLocation);
  readonly loading$: Observable<boolean> = this.select(
    state => state.callState === LoadingState.LOADING
  );

  // ViewModel for the component
  readonly vm$ = this.select(
    this.blogs$,
    this.blog$,
    this.blogEntries$,
    this.selectedBlogEntry$,
    this.loading$,
    this.showFirstEntry$,
    (blogs,blog, blogEntries, selectedBlogEntry, loading, error) => ({
      blogs,
      blog,
      blogEntries,
      selectedBlogEntry,
      loading,
      error
    })
  );

  // UPDATERS
  readonly updateError = this.updater((state: BlogState, error: string) => {
    return {
      ...state,
      callState: {
        errorMsg: error
      }
    };
  });

  readonly setLoading = this.updater((state: BlogState) => {
    return {
      ...state,
      callState: LoadingState.LOADING
    };
  });

  readonly setLoaded = this.updater((state: BlogState) => {
    return {
      ...state,
      callState: LoadingState.LOADED
    };
  });

  readonly updateBlogs = this.updater((state:BlogState,blogs:Blog[]) => {
    return {
      ...state,
      error:"",
      blogs:blogs
    };
  });

  readonly updateBlog = this.updater((state:BlogState,blog:Blog) => {
    return {
      ...state,
      error:"",
      selectedBlog:blog
    };
  })

  readonly updateBlogEntries = this.updater((state: BlogState, blogEntries: BlogEntry[]) => {
    return {
      ...state,
      error: "",
      blogEntries: blogEntries
    };
  });

  readonly noShowFirstEntry = this.updater(
    (state: BlogState) => {
        return {
            ...state,
            showFirstEntry: false,
        };
    }
  );

  readonly showFirstEntry = this.updater(
    (state:BlogState) => {
      return {
        ...state,
        showFirstEntry:true,
      }
    }
  )

  readonly updateSelectedBlogEntry = this.updater((state: BlogState, blogEntry: BlogEntry) => {
      return {
        ...state,
        selectedBlogEntry:blogEntry
      }
    }

  );

  //Effects
  readonly loadBlogEntries = this.effect((origin$: Observable<{"blogContentId":string}>) => {
    return origin$.pipe(
      map((blogParameters) => {
        this.setLoading();
        this.blogService.getBlogEntries(blogParameters.blogContentId)
        .subscribe((data:any) => {
          if(data["blogEntries"]){
            this.setLoaded();
            this.updateBlogEntries(data["blogEntries"]);
            this.updateBlog({"blogContentId":blogParameters.blogContentId});
            //this.state$.subscribe((data) => console.log(data.blogEntries));
            this.showFirstEntry$.subscribe((showFirstEntry) => {
              console.log(showFirstEntry);
              if(showFirstEntry){
                console.log("showFirst Entry is true");
                console.log(data["blogEntry"]);
                this.updateSelectedBlogEntry(data["blogEntry"]);
              }
            });
            
          }
        });
        //console.log(blogParameters)
      })
      /* tap((data:BlogEntry[]) => {

      }) */
    )
    /* return this.blogService.getBlogEntries()
      .subscribe((data:BlogEntry[]) => {
        
      }); */


  }
    
  );
 
  readonly setSelectedBlogEntry = this.effect((contentId$: Observable<string>) => {
    return contentId$;
  });

  readonly setSelectedBlog = this.effect((blog$:Observable<Blog>) => {
    return blog$;
  });
}
